import { render, staticRenderFns } from "./MBContainer.vue?vue&type=template&id=28a1a90a&scoped=true"
import script from "./MBContainer.vue?vue&type=script&lang=js"
export * from "./MBContainer.vue?vue&type=script&lang=js"
import style0 from "./MBContainer.vue?vue&type=style&index=0&id=28a1a90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1a90a",
  null
  
)

export default component.exports